import gql from 'graphql-tag'

export const GET_ADDRESS = gql`
  query Geofences($filter: GetGeofencesFilter) {
    geofences(filter: $filter) {
      status
      isSuccessful
      message
      errorName
      errorCode
      geofences {
        data {
          geofenceId
          companyId
          customerId
          fenceName
          type
          polyData
          circData
          address
          addressDetail
          province
          city
          postalCode
          category
          contactName
          phoneNo
          isGarage
          isServiceLoc
          isBillingAddr
          isDepot
          isAlert
          serviceStart
          serviceEnd
          breakStart
          breakEnd
          serviceLocType
          customerName
          hasRelation
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const CREATE_ADDRESS = gql`
  mutation CreateGeofence($input: CreateGeofenceInput!) {
    createGeofence(input: $input) {
      status
      isSuccessful
      message
      errorName
      errorCode
      geofence {
        geofenceId
      }
    }
  }
`

export const UPDATE_ADDRESS = gql`
  mutation UpdateGeofence($input: UpdateGeofenceInput!) {
    updateGeofence(input: $input) {
      status
      isSuccessful
      message
      errorName
      errorCode
      geofence {
        geofenceId
      }
    }
  }
`

export const GET_PROVINCES = gql`
  query Provinces($filter: ProvincesFilter) {
    data: provinces(filter: $filter) {
      isSuccessful
      provinces {
        ids
        pagination {
          total
          page
          show
        }
        data {
          regionId
          name
        }
      }
    }
  }
`

export const GET_CITIES = gql`
  query Cities($filter: CitiesFilter) {
    data: cities(filter: $filter) {
      isSuccessful
      cities {
        ids
        pagination {
          total
          page
          show
        }
        data {
          regionId
          parentId
          name
        }
      }
    }
  }
`

export const GET_DISTRICTS = gql`
  query Districts($filter: DistrictsFilter) {
    data: districts(filter: $filter) {
      isSuccessful
      districts {
        ids
        pagination {
          total
          page
          show
        }
        data {
          regionId
          parentId
          name
          city {
            name
          }
          province {
            name
          }
        }
      }
    }
  }
`

export const GET_REGION_BY_LAT_LNG = gql`
  query RegionByLatLng($filter: RegionByLatLngInput!) {
    data: regionByLatLng(filter: $filter) {
      isSuccessful
      regionByLatLng {
        province {
          regionId
          name
        }
        city {
          regionId
          name
        }
        district {
          regionId
          name
        }
      }
    }
  }
`

export const GET_DETAIL_ADDRESS = gql`
  query Geofence($filter: GetGeofenceInput!) {
    geofence(filter: $filter) {
      status
      isSuccessful
      message
      errorName
      errorCode
      geofence {
        geofenceId
        companyId
        customerId
        fenceName
        type
        polyData
        circData
        address
        addressDetail
        province
        city
        district
        postalCode
        category
        contactName
        phoneNo
        isGarage
        isServiceLoc
        isBillingAddr
        isDepot
        serviceStart
        serviceEnd
        breakStart
        breakEnd
        serviceLocType
        customerName
        hasRelation
        contacts {
          name
          phoneNo
          sendWhatsapp
        }
        operationalTime
        serviceDuration
        thirdPartyId
      }
    }
  }
`

export const DELETE_ADDRESS = gql`
  mutation DeleteGeofence($input: DeleteGeofenceInput!) {
    deleteGeofence(input: $input) {
      status
      isSuccessful
      message
      errorName
      errorCode
    }
  }
`

export const GET_ADDRESS_UPLOAD_HISTORY = gql`
  query ImportHistory($filter: ImportHistoriesFilter) {
    importHistory(filter: $filter) {
      isSuccessful
      message
      importHistory {
        filename
        importOn
        model
        totalFailed
        totalSuccess
        users {
          fullname
        }
      }
    }
  }
`
export const IMPORT_GEOFENCES = gql`
  mutation ImportGeofences($input: ImportGeofenceInput!) {
    importGeofences(input: $input) {
      importGeofences {
        errorFile
        totalData
        totalFailed
        totalSuccess
      }
      isSuccessful
      message
    }
  }
`

export const IMPORT_CUSTOMER_GEOFENCES = gql`
  mutation ImportCustomerGeofences($input: ImportCustomerGeofenceInput!) {
    importCustomerGeofences(input: $input) {
      importCustomerGeofences {
        errorFile
        totalData
        totalFailed
        totalSuccess
        __typename
      }
      isSuccessful
      message
      __typename
    }
  }
`

export const GET_IMPORT_CUSTOMER_GEOFENCES_TEMPLATE = gql`
  query ImportCustomerGeofenceTemplate {
    importCustomerGeofenceTemplate {
      isSuccessful
      errorCode
      errorName
      message
      status
      importCustomerGeofencesTemplate {
        templateFile
      }
    }
  }
`
